export default {
  Congress: 1,
  Secretariat: 2,
  PrimeMinister: 3,
  Minister: 4,
  ProvincialPeopleCommittee: 5,
};
